var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:outline-telegram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.9705 2.35809C7.54406 2.35809 2.32837 7.57378 2.32837 14.0003C2.32837 20.4267 7.54406 25.6424 13.9705 25.6424C20.397 25.6424 25.6127 20.4267 25.6127 14.0003C25.6127 7.57378 20.397 2.35809 13.9705 2.35809ZM19.3725 10.2748C19.1979 12.1142 18.4411 16.5848 18.0569 18.6455C17.8939 19.5186 17.568 19.8097 17.2653 19.8446C16.59 19.9028 16.0778 19.4022 15.4258 18.9715C14.4013 18.2962 13.8192 17.8771 12.8296 17.2251C11.677 16.4684 12.4221 16.0493 13.0857 15.374C13.2604 15.1994 16.2407 12.4868 16.299 12.2423C16.307 12.2053 16.306 12.1668 16.2958 12.1303C16.2857 12.0938 16.2668 12.0603 16.2407 12.0327C16.1709 11.9745 16.0778 11.9978 15.9963 12.0094C15.8915 12.0327 14.2616 13.1154 11.0833 15.2576C10.6176 15.5719 10.1985 15.7349 9.82592 15.7233C9.4068 15.7116 8.61513 15.4904 8.02138 15.2925C7.28793 15.0597 6.71746 14.9316 6.76403 14.5241C6.78732 14.3146 7.07837 14.105 7.62555 13.8838C11.0251 12.4053 13.2836 11.4273 14.4129 10.9616C17.6494 9.61116 18.3131 9.37831 18.7555 9.37831C18.8486 9.37831 19.0698 9.4016 19.2095 9.51802C19.3259 9.61116 19.3608 9.73922 19.3725 9.83236C19.3608 9.90221 19.3841 10.1118 19.3725 10.2748Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.5e6d7340286526a0b8f8f2dec6c14043.svg";
export { ForwardRef as ReactComponent };